import { notification } from 'antd';
import type { NotificationInstance } from 'antd/lib/notification/interface';
import { NOTIFY_DEFAULT_PROPS, notifyError, notifySuccess, notifyWarning } from 'utils/notifications';

/**
 * Fake hook so to we can implement true one later much easier.
 */
export const useAppNotifications = (): NotificationInstance => ({
  success: notifySuccess,
  error: args => notifyError(undefined, args),
  warning: notifyWarning,
  destroy: undefined,
  info: args =>
    notification.info({
      ...NOTIFY_DEFAULT_PROPS,
      ...args,
    }),
  open: args =>
    notification.open({
      ...NOTIFY_DEFAULT_PROPS,
      ...args,
    }),
});
